import { Company } from './company.base';

export const UpdateCompany = Company.pick({
  name: true,
  site: true,
  description: true,
});
